import { centerSelectedTab } from '../../utils/scroll';
import { useEffect, useRef, useState } from 'react';
import { cn } from './cn';

export type ScrollTab = { id: string; label: string };

/** Rangée d'onglets filtres: défilement horizontal, fondus aux bords, onglet actif toujours visible, trait animé. */
export default function ScrollTabs({ tabs, active, onChange, fadeFrom = 'from-white', className }: { tabs: ScrollTab[]; active: string; onChange: (id: string) => void; fadeFrom?: string; className?: string }) {
  const bar = useRef<HTMLDivElement>(null);
  const [fade, setFade] = useState({ left: false, right: false });

  const sync = () => {
    const el = bar.current;
    if (el) setFade({ left: el.scrollLeft > 4, right: el.scrollLeft + el.clientWidth < el.scrollWidth - 4 });
  };
  useEffect(() => {
    sync();
    const el = bar.current;
    if (!el) return;
    const ro = new ResizeObserver(sync);
    ro.observe(el);
    return () => ro.disconnect();
  }, [tabs.length]);
  useEffect(() => {
    centerSelectedTab(bar.current);
  }, [active]);

  return (
    <div className={cn('relative', className)}>
      <div ref={bar} onScroll={sync} className="overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        <div role="tablist" className="flex min-w-max gap-x-8 pb-1 md:gap-x-10">
          {tabs.map((t) => {
            const on = t.id === active;
            return (
              <button
                key={t.id}
                role="tab"
                aria-selected={on}
                onClick={() => onChange(t.id)}
                className={cn('relative shrink-0 whitespace-nowrap pb-2.5 text-left font-display text-lg font-semibold transition-colors', on ? 'text-charcoal' : 'text-muted hover:text-charcoal')}
              >
                {t.label}
                <span aria-hidden className={cn('absolute inset-x-0 bottom-0 h-0.5 origin-left bg-brand transition-transform duration-300', on ? 'scale-x-100' : 'scale-x-0')} />
              </button>
            );
          })}
        </div>
      </div>
      {fade.left && <span aria-hidden className={cn('pointer-events-none absolute inset-y-0 left-0 w-12 bg-gradient-to-r to-transparent', fadeFrom)} />}
      {fade.right && <span aria-hidden className={cn('pointer-events-none absolute inset-y-0 right-0 w-12 bg-gradient-to-l to-transparent', fadeFrom)} />}
    </div>
  );
}
